import React from "react";
import { withFormik, Form, Field } from "formik";
import { withAuthentication } from "../../../hoc/withAuthentication";
import { withRouter } from "react-router-dom";

import * as Yup from "yup";
import { digitInputHandler } from "../../../constants/utility";
import Alert from "../../../custom_components/alert";

const AdminPin = ({ errors, touched, isSubmitting, close }) => {
  let render = (
    <Form className="uk-form-stacked">
      {errors.success && (
        <Alert className="uk-alert-success">{errors.success}</Alert>
      )}

      <div className=" uk-text-small">
        Admin key will be used for sale checkouts, also used to enable/disable
        Store Mode. Type a 4 digit code for your admin key.
      </div>

      <div className={" uk-grid-small uk-margin-small-top"} uk-grid={1}>
        <div className="uk-width-1-1">
          <label className="uk-form-label" htmlFor="employeeCode">
            Admin Pin
          </label>
          <div className="uk-form-controls">
            <Field
              className="uk-input"
              id="employeeCode"
              name="employeeCode"
              type="text"
              placeholder="admin pin"
              onInput={(evt) => digitInputHandler(evt, 4)}
            />
          </div>
        </div>

        <div className="uk-width-1-1 uk-text-center">
          <button
            type="submit"
            className="uk-button uk-button-danger uk-width-1-1"
            disabled={isSubmitting}>
            {isSubmitting ? (
              <i className="fa fa-spinner fa-spin fa-fw"></i>
            ) : (
              "update"
            )}
          </button>
        </div>
      </div>
    </Form>
  );

  return render;
};

const FormikStoreInfo = withFormik({
  mapPropsToValues({ employeeCode }) {
    return {
      employeeCode: employeeCode || "",
    };
  },
  validationSchema: Yup.object().shape({
    employeeCode: Yup.number().required(),
  }),
  handleSubmit(values, { props, resetForm, setErrors, setSubmitting }) {
    const storeId = props.user.selectedShop;

    props.httpClient
      .put(`/account/employeeCode/${props.user._id}`, values)
      .then((res) => {
        setErrors({ success: "Admin pin has been updated successfully." });
        props.close && props.close();
      })
      .finally((res) => {
        setSubmitting(false);
      });
  },
})(AdminPin);

export default withAuthentication(withRouter(FormikStoreInfo));
